import { call } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import {
  PapiRequestDaDeviationBackgrounds,
  PapiDaDeviationBackgrounds,
  PapiRequestDaDeviationSetBackground,
  PapiDaDeviationSetBackground,
} from '@wix/da-papi-types';
import { getBackgrounds } from './_fixtures';

export function* doFetchBackgrounds(offset?: number, limit?: number) {
  const params: PapiRequestDaDeviationBackgrounds = {
    offset,
    limit,
  };

  const result: PapiDaDeviationBackgrounds | false = yield call(
    requestPuppy,
    {
      method: 'get',
      url: 'backgrounds',
      params,
    },
    () => {
      return { results: getBackgrounds(), hasMore: false };
    },
    'dadeviation'
  );

  return result;
}

export function* doSetBackground(deviationid: number, backgroundid?: number) {
  const data: PapiRequestDaDeviationSetBackground = {
    deviationid,
    backgroundid,
  };
  const result: PapiDaDeviationSetBackground | false = yield call(
    requestPuppy,
    {
      method: 'post',
      url: 'set_background',
      data,
    },
    () => {
      return { success: true };
    },
    'dadeviation'
  );
  return result;
}
